import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { NavOrExternalLink } from 'src/client/components/ui/NavOrExternalLink';
import styled from 'styled-components/macro';

type MobileFooterNavButtonProps = {
  className?: string;
  icon: IconProp;
  label: string;
  openInNewWindow?: boolean;
  to: string;
};

export const MobileFooterNavButton = (props: MobileFooterNavButtonProps) => {
  const { className, icon, label, openInNewWindow, to } = props;

  return (
    <MobileFooterNavLink className={className} to={to} openNewWindow={openInNewWindow}>
      <MobileFooterNavIcon icon={icon} fixedWidth aria-hidden="true" />
      <MobileFooterNavLabel>{label}</MobileFooterNavLabel>
    </MobileFooterNavLink>
  );
};

const MobileFooterNavLink = styled(NavOrExternalLink)`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: ${(props) => props.theme.headerBarPrimary2};
  text-decoration: none;
  padding: 10px 4px 12px;
  min-height: 100%;

  &:hover,
  &:focus {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};
  }

  &.discount {
    color: #78c274;

    &:hover,
    &:focus {
      color: #b9ffb5;
    }
  }
`;

const MobileFooterNavIcon = styled(FontAwesomeIcon)`
  font-size: 24px;
`;

const MobileFooterNavLabel = styled.span`
  font-size: 10px;
  font-weight: 400;
  text-transform: none;
  line-height: 1;
`;
